import React, { useEffect } from "react";

const AdditionalChargeRow = (props) => {
    const handleChange = (event, field) => {
        const value = event.target.value;
        let updatedCharges = [...props.inputs.additional_charges];
        updatedCharges[props.index][field] = value;
        const price = parseFloat(updatedCharges[props.index].price || 0);
        const qty = parseFloat(updatedCharges[props.index].qty || 0);
        updatedCharges[props.index].total = (price * qty).toFixed(2);
        props.setInputs((values) => ({
            ...values,
            additional_charges: updatedCharges,
        }));
    };
  
    return (
        <tr>
            <td>{props.index + 1}</td>
            <td>
                <textarea
                    className="form-control"
                    rows="2"
                    name="description"
                    value={props.data.description}
                    onChange={(e) => handleChange(e, "description")}
                    placeholder="Charge Description"
                ></textarea>

            </td>
            <td>
                <input
                    type="number"
                    className="form-control"
                    placeholder="Price"
                    name="price"
                    value={props.data.price}
                    onChange={(e) => handleChange(e, "price")}
                />
            </td>
            <td>
                <input
                    type="number"
                    className="form-control"
                    placeholder="Quantity"
                    name="qty"
                    value={props.data.qty}
                    onChange={(e) => handleChange(e, "qty")}
                />
            </td>
            <td>
                <input
                    type="text"
                    className="form-control"
                    value={props.data.total}
                    readOnly
                />
            </td>
            <td className="text-center">
                <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => props.deleteRowforAdditioanlcharges(props.index)}
                >
                    ×
                </button>
            </td>
        </tr>
    );
};

export default AdditionalChargeRow;
